import { message } from "antd";
import { authHeader } from "../../../../helpers/auth-header";
import { client } from "../../../../actions";
import uri from "../../constants/uri";

const createNotice = () => async (dispatch, getState) => {
	const fullState = getState();
	const createNotice = fullState.debtsStore?.createNotice || {};
	const debtors = fullState.debtsStore?.debts;
	try {
		const response = await client.post(
			`${uri}/create_notification`,
			{
				ReceivableIds: createNotice.debtors,
				Title: createNotice.title,
				FromDate: createNotice.start?.utc().format(),
				IsPush: createNotice.chosenNoticeTypes.PUSH,
				IsEmail: createNotice.chosenNoticeTypes.EMAIL,
				IsPhone: createNotice.chosenNoticeTypes.PHONE,
				IsSms: createNotice.chosenNoticeTypes.SMS,
				StartPush: createNotice.StartPush?.utc().format(),
				StartSms: createNotice.StartSms?.utc().format(),
				StartPhone: createNotice.StartPhone?.utc().format(),
				StartEmail: createNotice.StartEmail?.utc().format(),
				EmailId: createNotice.EmailId,
				EmailTemplateId: createNotice.EmailTemplateId,
				SmsTemplateId: createNotice.SmsTemplateId,
				PhoneTemplateId: createNotice.PhoneTemplateId,
				PushTemplateId: createNotice.PushTemplateId,
			},
			{
				headers: authHeader(),
			}
		);
		if (response.data.result === "Error") {
			const problemDebtor = debtors.map((debtor) => {
				if (debtor.id === response.data.id) {
					return debtor.account;
				}
			});
			message.error(
				`${response.data.message}: ${problemDebtor.filter(Boolean).join(", ")}`
			);
		}
		return response.data.id;
	} catch (error) {
		console.error(error);
		message.error("Не получилось создать оповещение");
	}
};

export default createNotice;
